// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__ahPDO","header":"ReportDetails_header__pTgJB","title":"ReportDetails_title__3vLkf","left":"ReportDetails_left__3oBG5"};